
import "./components.scss"

import CoinImg from "../assets/img/pre-coin.png"

const DescriptionPart = () => {
    return (
        <div className="w-full lg:w-[500px] min-h-[404px] flex flex-col">
            <div className="flex flex-col">
                <div className="text-[42px] md:text-[72px] leading-[79px] text-left">
                    FEDFROG <span className="text-[#0cafcc]">PRESALE</span>
                </div>
                <div className="text-[#FFFFFFBF] mt-4 text-left">Unlock unparalleled insights with FEDFROG, the native token powering SOL's next evolution.</div>
                <div className="flex flex-col mt-4">
                    <div className="flex flex-row items-start">
                        <img src="/assets/img/check.svg" className="pr-2" />
                        <div className="text-[#FFFFFFBF] text-left">
                            <span className="font-semibold text-white">Community Governance:</span> Participate in platform development and vote on feature proposals.
                        </div>
                    </div>
                    <div className="flex flex-row items-start mt-2.5">
                        <img src="/assets/img/check.svg" className="pr-2" />
                        <div className="text-[#FFFFBF] text-left">
                            <span className="font-semibold text-white">Staking Rewards:</span> Earn FEDFROG by staking your tokens and supporting the network.
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex gap-4 justify-center mt-6">
                <a
                    href="/Whitepaper.docx"
                    download="Whitepaper.docx"  // This will trigger a download with the given filename
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[166px] h-[36px] rounded-3xl px-4 py-2 border border-solid border-[#0cafcc] text-sm font-medium tracking-tight flex items-center justify-center hover:bg-[#0cafcc] hover:text-white"
                >
                    WhitePaper
                </a>


                <a 
                    href="https://t.me/FedcoinFrog"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[166px] h-[36px] rounded-3xl px-4 py-2 border border-solid border-[#0cafcc] text-sm font-medium tracking-tight flex items-center justify-center hover:bg-[#0cafcc] hover:text-white"
                >
                    Telegram
                </a>

                <a
                    href="https://x.com/FedCoinFROG?t=LoUS7QhuZ3-QRR5TZg2DXA&s=09"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[166px] h-[36px] rounded-3xl px-4 py-2 border border-solid border-[#0cafcc] text-sm font-medium tracking-tight flex items-center justify-center hover:bg-[#0cafcc] hover:text-white"
                >
                    Twitter
                </a>
            </div>

        </div>
    );
}

export default DescriptionPart;